var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeyondconcierge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 58.112,
    height: 44.366,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M3748.635,1335.461a10.144,10.144,0,0,0-.813,2.6l0-.016c-.228.178-.751.39-.789.742s.371.589.624.643v0a2.679,2.679,0,0,0,2.661,3.091,3.333,3.333,0,0,0,.374-.019s.148,1.249.18,1.561c.481-.109,2.4-.717,2.75-.831-.178-.448-.515-1.548-.649-1.882l.3-.256c.735-.634,2.254-4.237.613-5.317a6.937,6.937,0,0,0-3.5-1.066,1.844,1.844,0,0,0-1.748.748",
    transform: "translate(-3747.032 -1334.713)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 58.112,
    height: 44.366,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(-483 -682)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 60,
    height: 60,
    rx: 11,
    transform: "translate(483 682)",
    fill: "#5d44ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(483.727 687.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M1402.657,789.9l2.107-.449.964,4.492-2.14.368Z",
    transform: "translate(-1385.503 -779.799)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M1634.543,534.041l2.165-.458,1.516,7.064-2.141.358Z",
    transform: "translate(-1614.552 -527.061)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M1949.308,606.365l2.171-.388,1.2,5.579-2.141.358Z",
    transform: "translate(-1925.468 -598.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M2255.512,675.41l2.162-.388.89,4.146-2.139.368Z",
    transform: "translate(-2227.927 -666.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M2835,157.338l-.171-.1,1.959-3.416,3.22,2.1,2.261-4.547,3.433,2.144,2.873-5.28.173.094-2.973,5.464-3.426-2.14-2.263,4.551-3.231-2.1Z",
    transform: "translate(-2800.161 -146.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(0 -0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M2813.081,849.828a.431.431,0,1,1-.441-.361.4.4,0,0,1,.441.361",
    transform: "translate(-2777.832 -839.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M2966.169,588a.431.431,0,1,1-.441-.361.4.4,0,0,1,.441.361",
    transform: "translate(-2929.048 -580.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M3225.142,757.738a.431.431,0,1,1-.441-.361.4.4,0,0,1,.441.361",
    transform: "translate(-3184.854 -748.114)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M3412.053,380.161a.431.431,0,1,1-.442-.361.405.405,0,0,1,.442.361",
    transform: "translate(-3369.478 -375.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M3692.25,548.425a.431.431,0,1,1-.441-.361.4.4,0,0,1,.441.361",
    transform: "translate(-3646.249 -541.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M3834.541,137.964l-.134-1.753-1.416,1.188-.126-.151,1.71-1.435.163,2.136Z",
    transform: "translate(-3785.988 -134.152)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M2812.213,1332.389a5.142,5.142,0,0,0-1.825-2.683l-3.455,4.179,4.719,2.6a5.187,5.187,0,0,0,.562-4.1",
    transform: "translate(-2772.604 -1313.443)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M2713.1,1238.494a5.535,5.535,0,0,0-4.66-.974l1.2,5.154Z",
    transform: "translate(-2675.311 -1222.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M2356.576,1240.148a5.6,5.6,0,0,1-2.648-.663,5.26,5.26,0,0,1-2.079-7.339,5.653,5.653,0,0,1,3.37-2.594,5.395,5.395,0,1,1,2.939,10.375,5.8,5.8,0,0,1-1.581.221m.213-10.618a5.56,5.56,0,0,0-1.517.212,5.456,5.456,0,0,0-3.252,2.5,5.062,5.062,0,0,0,2,7.065,5.456,5.456,0,0,0,4.083.426,5.3,5.3,0,0,0,3.769-6.466,5.234,5.234,0,0,0-5.083-3.74",
    transform: "translate(-2322.358 -1214.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M3508.757,828.136l5.865-1.181a.558.558,0,0,1,.655.43l.444,2.079a.557.557,0,0,1-.432.663l-5.853,1.212a.558.558,0,0,1-.655-.413l-.5-2.042a.613.613,0,0,1,.475-.747",
    transform: "translate(-3465.358 -816.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M3051.513,1092.394l-.16-.116,3.582-4.968,2.329-.524.043.193-2.256.508Z",
    transform: "translate(-3014.034 -1073.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 4.627,
    height: 0.197,
    transform: "translate(44.537 12.767) rotate(-11.333)",
    fill: "#c3bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M143.363,42.069l-12.013-31.3a2.611,2.611,0,0,1,2.027-3.514L178.748.029a2.611,2.611,0,0,1,3.007,2.3L185.265,35Zm-9.97-34.715.016.1a2.413,2.413,0,0,0-1.874,3.248l11.955,31.148,41.56-7.011L181.558,2.35A2.414,2.414,0,0,0,178.779.224L133.408,7.452Z",
    transform: "translate(-129.571 0.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M388.5,754.379a.744.744,0,1,1-.83-.562.71.71,0,0,1,.83.562",
    transform: "translate(-382.29 -744.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M379.766,747.284a.8.8,0,0,1-.811-.655.739.739,0,0,1,.168-.58.891.891,0,0,1,1.168-.17.739.739,0,0,1,.326.509.81.81,0,0,1-.72.886.92.92,0,0,1-.131.01m.041-1.353a.721.721,0,0,0-.1.008.675.675,0,0,0-.428.236.544.544,0,0,0-.125.427.646.646,0,0,0,1.271-.184.544.544,0,0,0-.241-.374.664.664,0,0,0-.373-.112",
    transform: "translate(-374.313 -736.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M575.826,719.125a.744.744,0,1,1-.83-.562.71.71,0,0,1,.83.562",
    transform: "translate(-567.329 -709.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M567.1,712.029a.8.8,0,0,1-.811-.655.739.739,0,0,1,.168-.58.891.891,0,0,1,1.168-.169.739.739,0,0,1,.326.509.81.81,0,0,1-.72.886.909.909,0,0,1-.131.01m.041-1.353a.737.737,0,0,0-.1.007.676.676,0,0,0-.428.236.544.544,0,0,0-.125.427.646.646,0,0,0,1.271-.184.545.545,0,0,0-.241-.374.665.665,0,0,0-.373-.112",
    transform: "translate(-559.352 -701.789)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M754.928,692.114a.744.744,0,1,1-.83-.562.71.71,0,0,1,.83.562",
    transform: "translate(-744.24 -683.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M746.2,685.025a.8.8,0,0,1-.811-.655.74.74,0,0,1,.168-.58.872.872,0,0,1,.552-.306.809.809,0,0,1,.942.645.739.739,0,0,1-.168.58.872.872,0,0,1-.552.306.928.928,0,0,1-.131.009m.04-1.353a.719.719,0,0,0-.1.007.675.675,0,0,0-.428.236.544.544,0,0,0-.125.427.613.613,0,0,0,.718.478.675.675,0,0,0,.428-.236.545.545,0,0,0,.125-.427.6.6,0,0,0-.615-.486",
    transform: "translate(-736.262 -675.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M3065.745,1633.65a17.4,17.4,0,0,0-1.625-3.181,5.27,5.27,0,0,0-1.045-1.323c-.177-.165-.559-.4-.777-.234-.19.143-.159.334-.042.593-.21-.243-.438-.444-.721-.256-.268.177-.185.546-.118.695-.3-.262-.615-.417-.891-.235s-.15.582.031.828c-.462-.458-1.387-1.3-1.6-1.488-.323-.276-.753-.54-.983-.318s.131.815.542,1.234c.355.363,1.229,1.307,1.724,1.829.164.173.823.9.626,1.122-.138.155-.741-.128-1.049-.272-.327-.152-.906-.378-1.06-.128-.193.316.436.814,1.109,1.241a17.258,17.258,0,0,1,2.994,2.172c.391-.327,2.531-1.973,2.888-2.28",
    transform: "translate(-3020.501 -1608.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M3752.974,1341.351l.3-.256c.735-.634,2.254-4.237.613-5.317s-4.6-1.586-5.248-.318a10.144,10.144,0,0,0-.813,2.6l0-.016c-.228.178-.751.39-.789.742s.371.589.624.643v0a2.679,2.679,0,0,0,2.661,3.091,3.3,3.3,0,0,0,.374-.019s.147,1.249.179,1.561c.481-.109,2.4-.717,2.75-.831-.178-.448-.515-1.548-.649-1.882",
    transform: "translate(-3701.205 -1318.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M3863.722,1566.467c-.1.214-.276.345-.388.291s-.119-.27-.017-.484.276-.345.387-.291.12.27.017.484",
    transform: "translate(-3815.997 -1546.818)",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M3901.563,1474.013c-.066.227.219.2.405.345.117.088.361.4.481.3s0-.434-.23-.63-.591-.236-.656-.011",
    transform: "translate(-3853.836 -1455.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M3890.088,1748.337a9.664,9.664,0,0,0,.995-.378c.034.334-.041.709-.346.777s-.59-.278-.649-.4",
    transform: "translate(-3842.511 -1726.581)",
    fill: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M4215.3,1652.55a.544.544,0,0,1-.32-.094l.116-.16a.457.457,0,0,0,.423.011.361.361,0,0,0,.237-.242l.194.03a.544.544,0,0,1-.355.393.77.77,0,0,1-.294.061",
    transform: "translate(-4163.426 -1631.861)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(45.827 16.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M4041,1945.134l-.019-.2a3.839,3.839,0,0,0,.99-.339l.1.169a3.876,3.876,0,0,1-1.074.366",
    transform: "translate(-4037.391 -1937.14)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(0 -0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M1591.813,2239.53l14.433-2.767a.39.39,0,0,1,.462.349l.635,7.252,5.629,4.336-13.137,4.135a.39.39,0,0,1-.364-.07l-5.435-4.454-2.522-8.283a.39.39,0,0,1,.3-.5",
    transform: "translate(-1572.032 -2209.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 13.88,
    height: 0.197,
    transform: "translate(21.975 38.816) rotate(-16.524)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M2554.244,2966.06c-.489-.242-1.146-1.378-1.909-1.918a5.616,5.616,0,0,0-2.893-.784c-.546-.006-.973.079-1.038.339-.06.237.245.394.411.473-.49-.014-1.131.127-1.149.4-.021.335.366.5.743.562-.382.012-.866.134-.916.476-.028.193.231.34.663.446-.377.014-.657.221-.667.5-.007.191.348.374.748.5a11.539,11.539,0,0,1,3.762,2.307c.414-.605,1.988-2.937,2.245-3.305",
    transform: "translate(-2516.333 -2927.115)",
    fill: "#ed9970"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M2654.5,3022.036a5.433,5.433,0,0,0-2.014-.33l0-.1-.064-.075c.033-.029.033-.029.3-.02.131,0,.336.014.563.036a3.651,3.651,0,0,1,1.313.313Z",
    transform: "translate(-2619.98 -2984.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M2624.293,3100.479a4.218,4.218,0,0,0-2.114-.437l-.015-.2a4.383,4.383,0,0,1,2.233.467Z",
    transform: "translate(-2590.094 -3061.925)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M2603.739,3176.66a4.943,4.943,0,0,0-1.958-.58l.007-.2a5.139,5.139,0,0,1,2.042.6Z",
    transform: "translate(-2569.961 -3137.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M2936.938,2026.85c-.264-3.287-2.229-5.815-3.977-5.877a6.979,6.979,0,0,0-2.724.737,8.621,8.621,0,0,0-2.13,1.537,28.284,28.284,0,0,0-2.269-2.071c-.279.258-2.36,1.8-2.888,2.28.531,1.023,2.2,3.628,2.725,4.328-.334,1.51-.48,4.683-1.827,6.312-1.432,1.732-4.212,1.588-5.342,1.1-.427.624-1.875,2.669-2.246,3.305a10.812,10.812,0,0,0,6.174,2.015,7.98,7.98,0,0,0,4.67-1.833c3.036,1.12,8.242.615,9.878.008a103.089,103.089,0,0,0-.044-11.845",
    transform: "translate(-2880.594 -1996.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M2911.989,2032.653a10.986,10.986,0,0,1-6.077-2.04l-.064-.053.042-.072c.28-.481,1.179-1.771,1.773-2.625.2-.285.521-.753.521-.753l.074.032c1.082.463,3.815.632,5.228-1.076,1.012-1.224,1.342-3.385,1.583-4.963.075-.488.139-.913.215-1.263-.552-.744-2.168-3.268-2.707-4.305l-.035-.068.056-.051c.3-.266,1.066-.858,1.746-1.381.525-.4,1.021-.786,1.142-.9l.06-.056.066.049a28.523,28.523,0,0,1,2.208,2.006,8.623,8.623,0,0,1,2.084-1.48,7.122,7.122,0,0,1,2.774-.749,3.658,3.658,0,0,1,2.623,1.771,8.543,8.543,0,0,1,1.45,4.2,103.385,103.385,0,0,1,.043,11.866l-.008.059-.056.021a16.715,16.715,0,0,1-4.445.65,15.45,15.45,0,0,1-5.446-.638,8.131,8.131,0,0,1-4.687,1.819c-.053,0-.107,0-.163,0m-5.885-2.138a10.786,10.786,0,0,0,6.042,1.938,7.9,7.9,0,0,0,4.608-1.809l.044-.039.055.02a15.1,15.1,0,0,0,5.426.646,16.893,16.893,0,0,0,4.327-.617,104.76,104.76,0,0,0-.052-11.764c-.268-3.338-2.261-5.729-3.882-5.786a6.872,6.872,0,0,0-2.673.725,8.084,8.084,0,0,0-2.1,1.517l-.071.079-.074-.077a29.514,29.514,0,0,0-2.194-2.012c-.184.155-.609.482-1.093.854-.636.489-1.352,1.04-1.676,1.321.568,1.068,2.184,3.587,2.68,4.245l.027.036-.01.044c-.078.352-.145.789-.222,1.295-.244,1.6-.579,3.792-1.625,5.059-1.446,1.75-4.207,1.622-5.382,1.163-.107.155-.259.374-.432.622-.564.811-1.4,2.018-1.721,2.54",
    transform: "translate(-2870.308 -1988.287)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M3678.333,2206.2l-.194-.039a8.93,8.93,0,0,1,2.376-4.5l.08-.087.146.133-.08.088a8.746,8.746,0,0,0-2.329,4.4",
    transform: "translate(-3633.155 -2174.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M3797.407,2715.192l-.138-.141c2.245-2.2,3.917-6.862,4.551-9.269l.191.05c-.639,2.426-2.328,7.128-4.6,9.36",
    transform: "translate(-3750.828 -2672.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 0.197,
    height: 0.74,
    transform: "translate(39.779 21.675) rotate(-43.095)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 0.197,
    height: 0.649,
    transform: "translate(40.754 21.106) rotate(-37.736)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 0.197,
    height: 0.562,
    transform: "matrix(0.811, -0.586, 0.586, 0.811, 41.582, 20.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M3857.423,1215.373c.056.606.729,1.081,1.7,1.453,1.06.405,2.2.12,2.571,1.154.75-.236,1.588.245,1.619.8s-.23,1.162-1.361,1.221a6.315,6.315,0,0,0,.717,3.768c.792,1.73.173,3.407.543,4.379s1.883,1.674,3.732.832,1.592-3.291.829-5.022-2.009-2.6-2.445-4.536-.173-2.611-.9-4.184-2.875-1.886-4.174-1.812c-1.259.071-2.932.823-2.83,1.948",
    transform: "translate(-3810.242 -1198.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M407.8,1973.924a8.8,8.8,0,0,0-3.186,1.055,2.54,2.54,0,0,0-.851,2.952,18.033,18.033,0,0,0,1.876,4.29c.74,1.233,2.617,1.384,4.056,1.028a3.323,3.323,0,0,0,2.675-2.726,20.445,20.445,0,0,0,.381-4.6,2.215,2.215,0,0,0-1.83-2.007,8.4,8.4,0,0,0-3.12.005",
    transform: "translate(-398.697 -1949.635)",
    fill: "#85b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M1879.427,1393.888c-.23-.084-.617-.211-.824-.276a5.33,5.33,0,0,1-.484.745.764.764,0,0,1-.805.29c-.23-.084-.35-.32-.27-.669a4.309,4.309,0,0,1,.284-.79c-.188-.09-.652-.278-.861-.365a2.74,2.74,0,0,0-.571,1.734,1.388,1.388,0,0,0,.9,1.261,1.592,1.592,0,0,0,1.623-.238,2.656,2.656,0,0,0,1.007-1.693",
    transform: "translate(-1852.947 -1375.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M541.512,2858.707c0-.245-.009-.652-.018-.869a5.334,5.334,0,0,1-.864-.2.765.765,0,0,1-.545-.66c0-.245.183-.437.539-.479a4.279,4.279,0,0,1,.839,0c.021-.208.042-.708.054-.934a2.744,2.744,0,0,0-1.825.046,1.388,1.388,0,0,0-.884,1.274,1.591,1.591,0,0,0,.77,1.448,2.658,2.658,0,0,0,1.933.378",
    transform: "translate(-532.219 -2820.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M4,2201.521l.825,2.816a3.282,3.282,0,0,0-2.27,3.2c.169,2.408,3.589,1.917,3.589,1.917l.154,2.736s-4.836.428-6.071-3.813c-1.368-4.7,3.773-6.853,3.773-6.853",
    transform: "translate(0 -2174.596)",
    fill: "#85b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M1121.665,1272.285c.483-.3,1.247.493,1.706,1.542.437,1,.287,1.992-.292,2.105s-1.266-.972-1.493-1.609c-.368-1.03-.281-1.813.079-2.039",
    transform: "translate(-1107.634 -1256.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M159.814,1180.626c-.253-2.35,1.362-4.681,5.167-6.107s7.349.179,8.165,3.138-1.417,5.882-6.6,7.132c-4.937,1.19-6.557-2.549-6.731-4.164",
    transform: "translate(-157.835 -1159.634)",
    fill: "#85b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M250.16,1867.242a5.426,5.426,0,0,1-1.43-.193,4.166,4.166,0,0,1-2.442-1.671l.166-.107a4.68,4.68,0,0,0,5.184,1.536l.065.186a4.689,4.689,0,0,1-1.543.249",
    transform: "translate(-243.276 -1842.458)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 0.197,
    height: 3.523,
    transform: "matrix(0.705, -0.709, 0.709, 0.705, 3.694, 13.036)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 3.465,
    height: 0.197,
    transform: "matrix(0.059, -0.998, 0.998, 0.059, 7.615, 14.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M453.514,1385.723c-.277-1.276,1.076-2.881,3.932-3.824,2.49-.822,4.613-.381,5.041,1.025.485,1.593-.672,3.173-3.72,4.311-3.395,1.267-4.933-.04-5.253-1.512",
    transform: "translate(-447.933 -1364.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M597.86,1615.125a1.237,1.237,0,0,1,.311,1.365c-.211.367-.693.351-1.076-.036a1.237,1.237,0,0,1-.311-1.365c.211-.367.693-.351,1.076.036",
    transform: "translate(-589.387 -1595.075)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M998.877,1478.995a1.2,1.2,0,0,1-.094,1.4c-.324.3-.808.159-1.08-.315a1.2,1.2,0,0,1,.094-1.4c.324-.3.808-.159,1.08.315",
    transform: "translate(-985.323 -1460.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M833.019,1697.2a1.235,1.235,0,0,1-.943-.553l.156-.121a.9.9,0,0,0,1.051.42.848.848,0,0,0,.442-.939l.195-.032a1.044,1.044,0,0,1-.558,1.152.855.855,0,0,1-.343.072",
    transform: "translate(-821.899 -1675.238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M576.685,1954.39c.047.325.506.529,1.027.454s.905-.4.859-.724-.506-.529-1.027-.454-.905.4-.859.724",
    transform: "translate(-569.628 -1929.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M156.271,1672.843c-.441-1.255-1.119-1.634-1.909-1.5-.93.155-1.251,1.128-.763,2.441s1.349,1.776,2.054,1.576,1.115-1.1.618-2.514",
    transform: "translate(-151.496 -1650.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M456.343,2041.156a6.092,6.092,0,0,1-1.463-.168l.048-.192a7.5,7.5,0,0,0,4.39-.423l.073.183a8.37,8.37,0,0,1-3.048.6",
    transform: "translate(-449.317 -2015.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M1187.915,1647.167s-1.414,5.334-8.234,4.263l.641,3.525a11.445,11.445,0,0,0,6.106-2.159,8.673,8.673,0,0,0,3.246-4.606Z",
    transform: "translate(-1165.253 -1627.022)",
    fill: "#85b1ff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeyondconcierge);
export default __webpack_public_path__ + "static/media/beyondconcierge.c91c03ac729b25fa1cb79a401d7307d2.svg";
export { ForwardRef as ReactComponent };